<nb-card>
    <nb-card-header>Some shit</nb-card-header>
    <div class="form-grid-container">
        <div class="form-wrapper">
            <ubs-ofbiz-list 
                [fieldOptions]="fieldOptions" 
                [listOptions]="listOptions" 
                title="title" [state]="state$" 
                (overViewSelected)="showOverview($event)" 
                [searchResults]="result" 
                (editSelected)="showEditDialog($event)"
                (rowSelected)="rowSelected($event)" 
                [columnFields]="columnFields"
                [columnFieldTitles]="columnFieldTitles"
                [remoteFormData]="remoteFormData">
            </ubs-ofbiz-list>
            <!-- <ubs-ofbiz-form [ofbizForm]="addForm" [title]="title" [state]="state" [parameters]="parameters" (openDialogContainerEvent)="openDialogContainer($event)" [lookupSelectedValue]="lookupSelectedValue" [target]="target" (submitResult)="submitResult($event)"></ubs-ofbiz-form> -->
        </div>
    </div>
</nb-card>

